enum DistributorConstants {
  GET_DISTRIBUTORS_REQUEST = "GET_DISTRIBUTORS_REQUEST",
  GET_DISTRIBUTORS_SUCCESS = "GET_DISTRIBUTORS_SUCCESS",
  GET_DISTRIBUTORS_FAILURE = "GET_DISTRIBUTORS_FAILURE",

  CREATE_DISTRIBUTOR_REQUEST = "CREATE_DISTRIBUTOR_REQUEST",
  CREATE_DISTRIBUTOR_SUCCESS = "CREATE_DISTRIBUTOR_SUCCESS",
  CREATE_DISTRIBUTOR_FAILURE = "CREATE_DISTRIBUTOR_FAILURE",

  EDIT_DISTRIBUTOR_REQUEST = "EDIT_DISTRIBUTOR_REQUEST",
  EDIT_DISTRIBUTOR_SUCCESS = "EDIT_DISTRIBUTOR_SUCCESS",
  EDIT_DISTRIBUTOR_FAILURE = "EDIT_DISTRIBUTOR_FAILURE",

  RESET_DISTRIBUTOR_REQUEST = "RESET_DISTRIBUTOR_REQUEST",
  RESET_DISTRIBUTOR_LIST = "RESET_DISTRIBUTOR_LIST",
}

export default DistributorConstants;
